import { render, staticRenderFns } from "./AddSignatureComponent.vue?vue&type=template&id=9744c8f0&"
import script from "./AddSignatureComponent.vue?vue&type=script&lang=js&"
export * from "./AddSignatureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports